import { Fragment, useState, useEffect } from 'react';
import { updateCustomerTags } from '../api/api';
import Selector from './Selector';

// selected
const TagSelector = ({
  tags,
  customerTags,
  onSelect,
  onTagSelect,
  dietaryPreferences,
}) => {
  let [tagSelectors, setTagsSelectors] = useState([]);
  let [selectedTags, setSelectedTags] = useState([]);
  let [tagsIdMap, setTagsIdMap] = useState({});

  useEffect(() => {
    // create the selectors object for each tag
    // and also using the same loop, also save the
    // tags in an hashmap where t.id is the key and
    // tag is the value, to improve access time later on.
    let newTagsIdMap = {};
    setTagsSelectors(
      tags.map((t) => {
        newTagsIdMap[t.id] = t;
        return {
          tag: t,
          options: {
            0: { value: `${t.id} 1`, optionText: 'Absolutely' },
            1: { value: `${t.id} 0`, optionText: 'So-so' },
            2: { value: `${t.id} -1`, optionText: 'No thanks' },
          },
        };
      })
    );
    setTagsIdMap(newTagsIdMap);
  }, [tags]);

  useEffect(() => {
    // initial tags selection are the customerTags
    // folowing updates if tags or dietary preferences
    // changes is whatever tags were selected before.
    if (selectedTags.length) {
      setSelectedTagsAndRunOnSelect(selectedTags);
    } else {
      setSelectedTags(customerTags.map((t) => `${t.id} ${t.preference}`));
    }
  }, [tagsIdMap, dietaryPreferences, customerTags]);

  // Send request to save the selection in db.
  const saveTagSelection = (tagOption) => {
    // tagOption is a string example: "1 2"
    if (selectedTags.includes(tagOption)) return;
    let [tId, value] = tagOption.split(' ');
    updateCustomerTags({ [tId]: value });
  };

  const selectAndSaveTag = (tagOption) => {
    // tagOption is a string example: "1 2"
    if (selectedTags.includes(tagOption)) return;
    let [vId, _] = tagOption.split(' ');
    // remove tagOptions with same ID and add the new one in the selectedOnes.
    let filteredSelectedTags = selectedTags.filter((t) => {
      let [tId, _] = t.split(' ');
      return vId != tId;
    });
    const newSelectedTags = [...filteredSelectedTags, tagOption];

    // Adding this because this file is complex and over-engineered and we just need the tag option
    onTagSelect?.(tagOption);

    setSelectedTagsAndRunOnSelect(newSelectedTags);
    saveTagSelection(tagOption);
  };

  const setSelectedTagsAndRunOnSelect = (newSelectedTags) => {
    setSelectedTags(newSelectedTags);
    // This onSelect is to pass the selected tags to the parent.
    onSelect(
      newSelectedTags.reduce((acc, tagSelection) => {
        const [tagId, preference] = tagSelection.split(' ');
        // when a selection happens we pass the actual tags to the parent
        const tag = tagsIdMap[tagId];
        if (tag && parseInt(preference) >= 0) {
          acc.push(tag);
        }
        return acc;
      }, []),
      selectedTags,
      newSelectedTags
    );
  };

  return (
    <Fragment>
      {tagSelectors.map((tSel) => {
        let { tag, options } = tSel;
        return (
          <div
            key={tag.id}
            data-testid={`tag-container-${tag.name.toLowerCase()}`}
            className="tag-container hr-mb-16_fixed"
          >
            <div className="tag-name hr-mb-24 hr-horizontal-flex">
              <img className="tag-icon" src={tag.image_url} alt={tag.name} />
              <div className="hr-align-left tag-container-text-image">
                <div className="tag-name-content">
                  <div className="hr-paragraph-bold">{tag.name}</div>
                  <div className="hr-subtitle-sm">{tag.remark}</div>
                </div>
                <Selector
                  selected={selectedTags}
                  options={options}
                  action={(val) => selectAndSaveTag(val)}
                  type="pill"
                />
              </div>
            </div>
          </div>
        );
      })}
    </Fragment>
  );
};

export default TagSelector;
